import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { MAX_WIDTH_639PX } from '../../../../utils/common';
import useMeQuery from '../../../../utils/hook/react-query/user/useMeQuery';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import { usePathnameMethod } from '../../../../utils/hook/usePathnameMethod';
import { useRouterQuery } from '../../../../utils/hook/useRouterQuery';
import IngredientSearchButtons from '../components/IngredientSearchButtons';
import RecipeSearchBar from '../components/RecipeSearchBar';

const RecipeHeader = () => {
  const { pathnameIncludes } = usePathnameMethod();
  const { me } = useMeQuery();
  const history = useHistoryMethod();
  const { stringify } = useRouterQuery();
  const isMobile = useMediaQuery({ query: MAX_WIDTH_639PX });

  const [searchKeyword, setSearchKeyword] = useState('');

  const handleClickSearchBar = () => {
    if (isMobile && !pathnameIncludes('search=true')) {
      history.push('?search=true');
    }
  };

  return (
    <div className="flex-center flex-col gap-24px px-16px">
      <p className="my-8px text-26px font-bold text-gray-800 sm:my-0px sm:mb-4px">
        오늘의 채소 요리는?
      </p>
      <RecipeSearchBar
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
        onSearch={(keyword) =>
          history.push(`/recipes/search?${stringify({ q: keyword })}`)
        }
        onClickSearchBar={handleClickSearchBar}
      />
      {me && <IngredientSearchButtons center={!isMobile} />}
    </div>
  );
};

export default RecipeHeader;
